import { get, post, put } from "../utils/request";

/* 存储请求地址*/
export const requestUrl = {
  /* 消息中心 */
  message: "/xxy/basic/message/list", //消息中心获取列表

  departmentList: "/uaa/dept/list", //部门列表
  /* 设备定义 */
  processList: "/xxy/basic/procedure/list", //工序列表
  allProcess: "/xxy/basic/procedure/listAll", //工序列表
  orderList: "/xxy/basic/defineColumn/list", //订单列表
  warehouseList: "/xxy/basic/warehouse/list", //仓库列表
  zeroWarehouse: "/xxy/basic/warehouse/warehouseList", //仓库列表
  deviceList: "/xxy/basic/device/list", //设备列表
  deviceGroupList: "/xxy/basic/deviceGroup/list", //设备组列表
  removeDeviceGroup: "/xxy/basic/deviceGroup/remove", //删除设备组
  saveDeviceGroup: "/xxy/basic/deviceGroup/save", //增加设备组
  getDeviceList: "/xxy/basic/device/getInfo", //获取所有的设备列表
  getGroupDevice: "/xxy/basic/deviceGroup/getDevice", //获取设备组设备 ？id=
  removeGroupDevice: "/xxy/basic/deviceGroup/removeDevice", //删除设备组下的设备 ?id = 设备id
  deviceTypeList: "/xxy/basic/deviceType/list", //设备类型列表
  typeAttributeList: "/xxy/basic/deviceType/noPagedListAttribute", //设备类型属性列表
  getAttributeDetail: "/xxy/basic/deviceType/getAttributeDetail", //设备类型属性获取离线列表
  saveType: "/xxy/basic/deviceType/save",
  updateType: "/xxy/basic/deviceType/update",
  removeType: "/xxy/basic/deviceType/remove",
  batchRemoveType: "/xxy/basic/deviceType/batchRemove",
  saveAttribute: "/xxy/basic/deviceType/saveAttribute",
  updateAttribute: "/xxy/basic/deviceType/updateAttribute",
  removeAttribute: "/xxy/basic/deviceType/removeAttribute",
  saveDevice: "/xxy/basic/device/save",
  updateDevice: "/xxy/basic/device/update",
  removeDevItem: "/xxy/basic/device/remove",
  batchRemoveDev: "/xxy/basic/device/batchRemove",
  getIpcList: "/xxy/basic/ipc/getInfo", //工控机-下拉框列表
  getWorkshopList: "/xxy/basic/workshop/getInfo", //车间-下拉框列表

  /* 数据字典 */
  dictList: "/xxy/common/dict/list", //获取字典列表
  dictTypeList: "/xxy/common/dict/type", //获取字典类型列表
  saveDict: "/xxy/common/dict/save", //新增字典
  updateDict: "/xxy/common/dict/update", //更新字典
  removeDict: "/xxy/common/dict/remove", //删除字典
  batchRemoveDict: "/xxy/common/dict/batchRemove", //删除字典

  /* 工序 */
  devTypeList: "/xxy/basic/deviceType/list", //设备类型列表
  // processList: '/xxy/basic/procedure/list',//工序列表
  saveProcedure: "/xxy/basic/procedure/save", //新增工序
  updateProcedure: "/xxy/basic/procedure/update", //更新工序信息
  deleteProcedure: "/xxy/basic/procedure/remove", //删除工序信息

  /* 订单定义 */
  // orderList: '/xxy/basic/defineColumn/list',//订单列表
  saveOrder: "/xxy/basic/defineColumn/save", //新增订单定义
  updateOrder: "/xxy/basic/defineColumn/update", //更新订单定义
  removeOrder: "/xxy/basic/defineColumn/remove", //删除订单定义

  /* 仓库类型定义 */
  warehouseTypeList: "/xxy/basic/warehouseType/list", //仓库类型列表
  savewarehouseType: "/xxy/basic/warehouseType/save", //新增仓库类型
  updateWarehouseType: "/xxy/basic/warehouseType/update", //新增仓库类型
  deleteWarehouseType: "/xxy/basic/warehouseType/remove", //删除仓库类型
  getAllWarehouseType: "/xxy/basic/warehouseType/listAll", //获取所有仓库类型

  /* 仓库定义 */
  // warehouseList: "/xxy/basic/warehouse/listAll", //仓库列表
  getAllwarehouse: "/xxy/basic/warehouse/listAll", //仓库列表
  savewarehouse: "/xxy/basic/warehouse/save", //新增仓库
  updateWarehouse: "/xxy/basic/warehouse/update", //新增仓库
  bomList: "/xxy/basic/bom/pagedList", //物料列表
  bomNoPagedList: "/xxy/basic/bom/list",
  deleteWarehouse: "/xxy/basic/warehouse/remove",
  mudSave: "/xxy/mould/mouldStock/save", //新增、编辑工具仓库
  adrList: "/xxy/mould/mouldStock/list", //工具仓库列表
  /* 产能定义 */
  capacityList: "/xxy/basic/capacity/list", //产能列表
  allBomList: "/xxy/basic/material/getInfo", //所有物料列表
  techLine: "/xxy/basic/capacity/techlineInfo", //获取工艺路线
  removeCapacity: "/xxy/basic/capacity/remove", //删除产能定义
  batchRemoveCapacity: "/xxy/basic/capacity/batchRemove", //批量删除产能定义
  saveCapacity: "/xxy/basic/capacity/save", //保存产能定义
  removeDevice: "/xxy/basic/deviceList/remove", //保存产能定义
  batchRemoveDevice: "/xxy/basic/deviceList/batchRemove", //保存产能定义
  editCapacity: "/xxy/basic/capacity/edit", //修改产能定义

  /* 工厂日历 */
  calendarList: "/xxy/basic/calender/list", //获取日历列表
  saveCalendar: "/xxy/basic/calender/save", //保存日历
  updateCalendar: "/xxy/basic/calender/update", //修改日历
  copyCalendar: "/xxy/basic/calender/copy", //复制日历
  removeCalendar: "/xxy/basic/calender/remove", //删除日历

  /* 工艺路线 */
  techLineList: "/xxy/basic/techline/list", //工艺路线列表
  listProcedure: "/xxy/basic/procedure/getInfo", //工艺路线-工序列表
  removeTechLine: "/xxy/basic/techline/remove", //删除工艺路线
  batchRemoveTechLine: "/xxy/basic/techline/batchRemove", //删除工艺路线
  noTechLine: "/xxy/basic/material/getNotConfigured", //未配置工艺路线的物料
  saveTechLine: "/xxy/basic/techline/save", //保存工艺路线
  updateTechLine: "/xxy/basic/techline/edit", //修改工艺路线
  showFile: "/xxy/basic/techline/showFile",
  getProcedureById: "/xxy/basic/device/getDeviceByProcedure",

  /* 物料定义 */
  getMaterial: "/xxy/basic/material/list", //物料定义
  saveMaterial: "/xxy/basic/material/save",
  removeMaterial: "/xxy/basic/material/remove",
  syncMaterial: "/xxy/basic/material/sync",
  syncBom: "/xxy/basic/bom/sync",
  getDeviceListByWorkShop: "/xxy/basic/device/getInfoByWorkshopId",

  /* Bom 定义 */
  addBom: "/xxy/basic/bom/add",
  saveBom: "/xxy/basic/bom/save", //保存物料定义
  updateBom: "/xxy/basic/bom/update", //编辑物料定义
  removeBom: "/xxy/basic/bom/remove", //编辑物料定义
  getBomList: "/xxy/basic/material/getInfo",
  getBomSec: "/xxy/basic/bom/getSubList", //获取bomm下级

  /* 质检定义 */
  resultData: "/xxy/inspect/inspecresult/listByWorkId",
  getWorkInfo: "/xxy/inspect/inspecresult/list",

  /* 工厂建模 */
  getPlantList: "/xxy/basic/factory/list",
  getWorkShop: "/xxy/basic/workshop/list",
  deletePlant: "/xxy/basic/factory/remove",
  deleteWorkShop: "/xxy/basic/workshop/remove",
  savePlant: "/xxy/basic/factory/save",
  saveWorkShop: "/xxy/basic/workshop/save",
  getAllPlant: "/xxy/basic/factory/getInfo",

  /* 工艺参数 */
  paramsList: "/xxy/basic/deviceParam/list",
  saveParams: "/xxy/basic/deviceParam/save",
  deleteParams: "/xxy/basic/deviceParam/remove",

  /* 终端定义 */
  ipcList: "/xxy/basic/ipc/list",
  saveIpc: "/xxy/basic/ipc/save",
  deleteIpc: "/xxy/basic/ipc/remove",

  /*工具定义 */
  getToolsList: "/xxy/mould/mould/list", //获取工具列表get*/
  saveTools: "/xxy/mould/mould/save", //工具保存接口post*/
  removeTools: "/xxy/mould/mould/remove", //工具删除接口post*/
  checkoutTools: "/xxy/mould/mould/stock", //工具出库接口post*/
  toolsWareList: "/xxy/mould/mouldWarehouse/list", //工具库接口save remove
  deleteWare: "/xxy/mould/mouldWarehouse/remove",
  deleteWareStock: "/xxy/mould/mouldStock/remove", //删除工具仓库定义
  getToolsLife: "/xxy/mould/mouldLife/list", //工具寿命查询
  getMaterialListInfo: "/xxy/basic/material/getInfo", //物料列表
  getDevicetypeInfo: "/xxy/basic/deviceType/listAll", //设备列表
  getWarehouseList: "/xxy/mould/mouldWarehouse/listAll", //库位（仓库）信息
  saveWarehouse: "/xxy/mould/mouldWarehouse/save", //工具库新增
  getMouldInfo: "/xxy/mould/mould/getInfo",
  getTool: "/xxy/mould/mould/listAll", //工具-下拉框
  stockInOut: "/xxy/mould/mould/stock", //出入库
  stockHistory: "/xxy/mould/mould/stockList", //出入库记录

  /* 客户定义 */
  clientList: "/xxy/basic/client/list",
  saveClient: "/xxy/basic/client/save",
  deleteClient: "/xxy/basic/client/remove",

  /* 供应商定义 */
  supplierList: "/xxy/basic/supplier/list",
  saveSupplier: "/xxy/basic/supplier/save",
  deleteSupplier: "/xxy/basic/supplier/remove",

  /* 客户地址定义 */
  clientAddressList: "/xxy/basic/clientAddress/listAll",
  saveAddressClient: "/xxy/basic/clientAddress/save",
  deleteAddressClient: "/xxy/basic/clientAddress/remove"
};

/* 测试接口的数据 */
export async function getRequest(url, data, options) {
  return await get(url, data, options);
}

/* 测试接口的数据 */
export async function postRequest(url, data, options) {
  return await post(url, data, options);
}
/* 测试接口的数据 */
export async function putRequest(url, data, options) {
  return await put(url, data, options);
}
